export const environment = {
  name: 'dev',
  production: false,

  apiBaseUrl: 'https://api.dev.inv.platepath.com',
  platformApiBaseUrl: 'https://api.dev.plt.platepath.com',

  apps: {
    platformWeb: 'https://dev.plt.platepath.com',
    inventoryWeb: 'https://dev.inv.platepath.com',
  },
};
